import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建揽收司机
export const CREATE_ACCOUNT_PICKUP_DRIVER = gql`
    mutation CreateAccountPickupDriver($input: AccountPickupDriverInput!) {
        createAccountPickupDriver(input: $input)
    }
`;

// 更新揽收司机
export const UPDATE_ACCOUNT_PICKUP_DRIVER = gql`
    mutation UpdateAccountPickupDriver($input: AccountPickupDriverInput!) {
        updateAccountPickupDriver(input: $input)
    }
`;

export interface AccountPickupDriverInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    warehouseId: number;
    vehicleId?: number;
    workWeekdaysJson: string;
    workStartTime: string;
    workEndTime: string;
    responsibleZipcodeListJson?: string;
    role: string;
}

export const createAccountPickupDriver = async (input: AccountPickupDriverInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_PICKUP_DRIVER,
        variables: {input}
    });
    return data.createAccountPickupDriver;
};

export const updateAccountPickupDriver = async (input: AccountPickupDriverInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_PICKUP_DRIVER,
        variables: {input}
    });
    return data.updateAccountPickupDriver;
}; 